import { createContext, useCallback, useContext, useState } from "react";
import { EnquiryModal } from "./EnquiryModal";

const EnquiryContext = createContext(null);

export const useEnquiry = () => useContext(EnquiryContext);

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openEnquiry = useCallback((data = {}) => {
    setPrefill(data);
    setOpen(true);
    window.__lenis?.stop();
  }, []);

  const closeEnquiry = useCallback(() => {
    setOpen(false);
    window.__lenis?.start();
  }, []);

  return (
    <EnquiryContext.Provider value={{ open, openEnquiry, closeEnquiry }}>
      {children}
      <EnquiryModal open={open} prefill={prefill} onClose={closeEnquiry} />
    </EnquiryContext.Provider>
  );
};
